import React from 'react';
import { Link } from 'react-router-dom';

function Logo() {
  return <Link to="/" className="brand" aria-label="CaseMining home"><span>CaseMining</span><img src="/original-logo.png" alt="" className="original-logo" /></Link>;
}

export default Logo;
